import { render, staticRenderFns } from "./createGroup.vue?vue&type=template&id=24bb4aa3&scoped=true"
import script from "./createGroup.vue?vue&type=script&lang=js"
export * from "./createGroup.vue?vue&type=script&lang=js"
import style0 from "./createGroup.vue?vue&type=style&index=0&id=24bb4aa3&prod&lang=scss&scoped=true"
import style1 from "./createGroup.vue?vue&type=style&index=1&id=24bb4aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb4aa3",
  null
  
)

export default component.exports